import { RandomId } from "@swivl-mono/helpers";
import { NodeData_PaymentLink, NodeInterface, NodeType, PaymentSessionMode, VarKey } from "@swivl-mono/types";
import { Select, SelectItem } from "@swivl-mono/ui";

import UserVariablesDropdown from "../../../../Components/Dropdowns/UserVariablesDropdown/UserVariablesDropdown";
import { TagInput, TagInputType } from "../../../../Components/TagInput/TagInput";
import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "./NodePanel";

const PaymentLinkNode = {
  Type: NodeType.PaymentLink,
  Empty: function () {
    const node: NodeData_PaymentLink = {
      id: RandomId(6),
      type: NodeType.PaymentLink,
      saveToVar: VarKey.UserShortURL,
      expiresAfterInMinutes: 30,
      mode: PaymentSessionMode.LIVE,
      goto: "",
      invalidGoto: "",
      channel: "",
      source: ""
    };

    return node;
  },
  PlumbData: function (_node: NodeInterface) {
    const node = _node as NodeData_PaymentLink;
    const tabs = [
      {
        id: "goto",
        source: "goto",
        target: node.goto,
        title: "Success"
      },
      {
        id: "invalidGoto",
        source: "invalidGoto",
        target: node.invalidGoto,
        title: "Invalid"
      }
    ];

    return TabNodeLayoutData({
      node: node,
      title: "Payment Link",
      body: "",
      baseWidth: 150,
      tabs
    });
  },

  InspectorPanel: class InputInspectorPanel extends NodePanel {
    render() {
      const node = this.props.node as NodeData_PaymentLink;

      return (
        <div>
          <div className="panel message_panel">
            <InspectorNodeHeader title="Validation" />
            <label>Payment Link Generation</label>
            <br />
            <label>Save Payment Link To</label>
            <UserVariablesDropdown onChange={this.onChange} skipUserId={true} name={"saveToVar"} value={node.saveToVar} />
            <Select
              label="Expires After"
              hideClear
              selectedValues={[String(node.expiresAfterInMinutes ?? "")]}
              options={
                [
                  { value: "", label: "No Expiration" },
                  { value: "1", label: "1 Minute" },
                  { value: "5", label: "5 Minutes" },
                  { value: "15", label: "15 Minutes" },
                  { value: "30", label: "30 Minutes" }
                ] as SelectItem[]
              }
              onChange={(vals) =>
                this.onChange({ target: { name: "expiresAfterInMinutes", value: vals[0] === "" ? undefined : Number(vals[0]) } } as any)
              }
            />
            <Select
              label="Mode"
              hideClear
              selectedValues={[node.mode || PaymentSessionMode.LIVE]}
              options={
                [
                  { value: PaymentSessionMode.LIVE, label: "Live" },
                  { value: PaymentSessionMode.TEST, label: "Test" }
                ] as SelectItem[]
              }
              onChange={(vals) => this.onChange({ target: { name: "mode", value: vals[0] as PaymentSessionMode } } as any)}
            />
            <TagInput
              label="Channel"
              type={TagInputType.SingleLine}
              value={node.channel || ""}
              onChange={this.onChange}
              name="channel"
              placeholder="Channel..."
            />
            <TagInput
              label="Source"
              type={TagInputType.SingleLine}
              value={node.source || ""}
              onChange={this.onChange}
              name="source"
              placeholder="Source..."
            />
          </div>
          <InspectorFooter deleteNode={this.deleteNode} node={node} duplicateNode={this.props.duplicateNode} canDuplicate={this.props.canDuplicate} />
        </div>
      );
    }
  }
};
export default PaymentLinkNode;
